<template>
    <div v-loading="isLoading || form.busy">
        <div v-if="bot">
            <div class="form-group">
                <input class="form-control" type="text" v-model="bot.name" placeholder="Имя">
                <has-error :form="form" field="name" class="d-block"/>
            </div>
            <div class="form-group">
                <input class="form-control" type="text" v-model="bot.username" placeholder="Имя пользователя">
                <has-error :form="form" field="username" class="d-block"/>
            </div>
            <div class="form-group">
                <input class="form-control" type="password" v-model="bot.token" placeholder="API Токен" autocomplete="off">
                <has-error :form="form" field="token" class="d-block"/>
            </div>
            <div class="form-group">
                <Select2 v-model="bot.platform_id" :options="platform_select" :id="'platform_id'" :settings="{width: '100%'}" :required="true" placeholder="Площадка"/>
                <has-error :form="form" field="platform_id" class="d-block"/>
            </div>
            <div class="form-group" v-if="bot.id">
                <span>Статус подключения к боту</span> <span v-if="bot.is_active" class="badge badge-success">Подключен</span> <span v-if="!bot.is_active" class="badge badge-danger">Ошибка</span>
                <div class="small text-muted" v-if="bot.error">{{bot.error}}</div>
            </div>
            <div class="form-group text-center">
                <button class="btn btn-primary" type="button" @click.prevent="save" :disabled="form.busy">Сохранить</button>
            </div>
        </div>
    </div>
</template>

<script>
import Form from "vform";
import Multiselect from "vue-multiselect";
import PlatformHelper from "../../helpers/platform";
import {mapGetters} from "vuex";

export default {
    name: "BotForm",
    components: {Multiselect},
    props: ['bot_id'],
    data: () => ({
        isLoading: true,
        bot: {
            name: null,
            username: null,
            token: null,
            platform_id: null,
            is_active: null,
        },
        form: new Form({}),
        saving: false,
    }),
    mounted() {
        if (this.bot_id) {
            this.fetchBot();
        } else {
            this.isLoading = false;
        }
    },
    computed: {
        platform_select() {
            let select = [];
            let self = this;
            this.$store.getters['auth/user'].allowed_platforms
                .forEach(function (item) {
                    select.push({
                        id: item.id,
                        text: item.name,
                    })
                });
            select = _.sortBy(select, ['text']);
            return select;
        },
    },
    methods: {
        save() {
            let self = this;
            self.saving = true;
            this.form = new Form({
                name: this.bot.name,
                username: this.bot.username,
                token: this.bot.token,
                platform_id: this.bot.platform_id,
            });
            let method = null;
            let url = null;
            let id = this.bot.id ? this.bot.id : this.bot_id;
            if (id) {
                method = 'put';
                url = '/api/telegram-bots/' + id;
            } else {
                method = 'post';
                url = '/api/telegram-bots';
            }
            this.form.submit(method, url)
                .then(response => {
                    self.$message.success({
                        message: 'Сохранено',
                        duration: 2000,
                    });
                    self.$emit('updated', response.data);
                    self.saving = false;
                    self.bot = response.data;
                })
                .catch(() => {
                    self.isLoading = false;
                    self.saving = false;
                    self.$message.error({
                        message: 'Ошибка, проверьте поля!',
                        duration: 2000,
                    });
                })
        },
        fetchBot() {
            let self = this;
            self.isLoading = true;
            axios.get('/api/telegram-bots/' + this.bot_id)
                .then(res => {
                    self.bot = res.data;
                    self.isLoading = false;
                })
        },
    }
}
</script>


<style scoped>

</style>
